export default __webpack_public_path__ + "static/media/sticker-F.5017a65e.png";